export enum Level {
  ATOMS = 'Cheetah / Atoms',
  MOLECULES = 'Cheetah / Molecules',
  ORGANISMS = 'Cheetah / Organisms',
  TEMPLATES = 'Cheetah / Templates',
}

export enum ResponsiveSize {
  MOBILE_MAX_WIDTH = 400,
  TABLET_MAX_WIDTH = 770,
  DESKTOP_MAX_WIDTH = 1920,
}

export enum ResponsiveSizeV2 {
  MOBILE_WIDTH = 600,
  MOBILE_MAX_WIDTH = 450,
  DESKTOP_MIN_WIDTH = 768,
}
